import { render, staticRenderFns } from "./HeaderPage.vue?vue&type=template&id=4cb5bda5&"
import script from "./HeaderPage.vue?vue&type=script&lang=js&"
export * from "./HeaderPage.vue?vue&type=script&lang=js&"
import style0 from "./HeaderPage.vue?vue&type=style&index=0&id=4cb5bda5&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports